var searchPage = {};

(function (searchPageApp) {
	var filterModel = {
		SearchTerm: "",
		Content: "",
		ProductPage: 1,
		Page: 1,
		IsSearchPage: true
	};

	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.SearchTerm) {
				queryArray.push("search=" + filterModel.SearchTerm);
			}
			if (filterModel.Content) {
				queryArray.push("content=" + filterModel.Content);
			}
			if (filterModel.ProductPage) {
				queryArray.push("productpage=" + filterModel.ProductPage);
			}
			if (filterModel.Page) {
				queryArray.push("page=" + filterModel.Page);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.SearchTerm = null;
		filterModel.Content = "";
		filterModel.ProductPage = 1;
		filterModel.Page = 1;
		searchPageApp.setInputValue();

		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "search") {
					filterModel.SearchTerm = val;
					searchPageApp.setInputValue();
				} else if (key === "content") {
					filterModel.Content = val;
				}  else if (key === "productpage") {
					filterModel.ProductPage = val;
				} else if (key === "page") {
					filterModel.Page = val;
				}
			}
		}
		searchPageApp.GetSearchResults();
	}

	function setContentLinkActive() {
		$(".js-content-link").removeClass("is-active");
		if (typeof filterModel.Content === 'undefined' || filterModel.Content === null) {
			filterModel.Content = "";
		}
		$('.js-content-link[data-content="' + filterModel.Content + '"]').addClass('is-active');
	}

	searchPageApp.setInputValue = function () {
		$(".js-search-field").val(filterModel.SearchTerm);
	};

	searchPageApp.GetSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/GransRemedySearchSurface/GetFilterResult",
			type: "GET",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results").html(data);
				$(".js-search-results").show();
				pushHistory();
				searchPageApp.setInputValue();
				setContentLinkActive();
			}
		});
	};

	searchPageApp.GetContentSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/GransRemedySearchSurface/GetContentSearchResults",
			type: "GET",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-article-search-grid").html(data);
				pushHistory();
				searchPageApp.setInputValue();
				setContentLinkActive();
			},
			error: function (xhr, status, error) {
				console.log(status);
				console.log(xhr.status + " - " + error);
			}
		});
	};

	$(document).ready(function () {
		let timer;

		//Get url params on load
		const urlParams = new URLSearchParams(window.location.search);

		//check if querystring params exist on load/reload
		if (urlParams.get('search')) {
			filterModel.SearchTerm = urlParams.get('search');
			searchPageApp.setInputValue();
		}

		if (urlParams.get('content')) {
			filterModel.Content = urlParams.get('content');
			searchPageApp.setInputValue();
		}

		if (urlParams.get('productpage'))
			filterModel.ProductPage = urlParams.get('productpage');

		if (urlParams.get('page'))
			filterModel.Page = urlParams.get('page');


		$(".js-search-field").on("keyup change", debounce(searchFromField, 1000));

		function debounce(func, timeout = 300){
			return (...args) => {
				clearTimeout(timer);
				timer = setTimeout(() => { func.apply(this, args); }, timeout);
			};
		}
		function searchFromField($event) {
			filterModel.SearchTerm = $event.target.value;
			filterModel.Content = $('.js-content-link.is-active').data("content");
			filterModel.ProductPage = 1;
			filterModel.Page = 1;
			filterModel.IsSearchPage = true;
			searchPageApp.GetSearchResults();
		}

		$(".js-search-button").on('click', function (e) {
			e.preventDefault();
			clearTimeout(timer);
			filterModel.Content = $('.js-content-link.is-active').data("content");
			setFilterModel();
			searchPageApp.GetSearchResults();
		});

		$(".js-header-search-button").on('click', function (e) {
			e.preventDefault();
			$(".js-search-field").click();
		});

		$('body').on('click', '.js-all-link', function (e) {
			e.preventDefault();
			filterModel.Content = "";
			setFilterModel();
			searchPageApp.GetContentSearchResults();
		});

		$('body').on('click', '.js-other-link', function (e) {
			e.preventDefault();
			filterModel.Content = $(this).data("content");
			setFilterModel();
			searchPageApp.GetContentSearchResults();
		});

		$('body').on('click', '.js-article-link', function (e) {
			e.preventDefault();
			filterModel.Content = $(this).data("content");
			setFilterModel();
			searchPageApp.GetContentSearchResults();
		});

		function setFilterModel() {
			var values = $(".js-search-field");
			filterModel.SearchTerm = $(".js-search-field").val();
			filterModel.ProductPage = 1;
			filterModel.Page = 1;
			filterModel.IsSearchPage = true;
		}


		//on pagination click event
		$(document).on('click', 'div.pagination a', function (e) {
			e.preventDefault();
			if ($(this).hasClass('js-product')) {
				filterModel.ProductPage = $(this).data('page');
				paginationScrollToTop(".js-product-search-grid");
				searchPageApp.GetSearchResults();
			}
			else if ($(this).hasClass('js-all')) {
				filterModel.Page = $(this).data('page');
				searchPageApp.GetContentSearchResults();
				paginationScrollToTop(".js-article-search-grid");
			}
		});

		function paginationScrollToTop(classToScroll) {
			$('html, body').animate({
				scrollTop: $(classToScroll).offset().top - $("header").outerHeight()
			}, 400);
		}
	});

})(searchPage);
